import BaseStore from 'stores/base'

export default class InvoiceStore extends BaseStore {
  constructor(service, options) {
    super(service)
    this.service = service
  }
}
